import { LogLevel } from "./models/index.js";
export const defaultConfigs = {
    //
    // CORE -----------------------------
    // -------------------------------------
    app: '',
    mode: 'standard',
    app_version: '0',
    version: '1.98.9', // __version__ the string will be replaced with the actual version during bundles upload in upload-bundles.mjs
    logLevel: LogLevel.Error,
    locksMaxAge: 86400000,
    //
    // STORAGE -----------------------------
    // -------------------------------------
    storagePrefix: 'paa_',
    keyPulseSyncCookie: 'pulse-state',
    hashStoreStorageType: 'persistent',
    stateStorageKey: 'ss',
    // Other
    handledErrorPrefix: 'HANDLED ERROR >>>',
};
//# sourceMappingURL=configuration.js.map